import { Type } from 'class-transformer';
import {
  Equals,
  IsBoolean,
  IsDate,
  IsEmail,
  IsNumber,
  IsNumberString,
  IsOptional,
  IsString,
  Matches
} from 'class-validator';

export class GiftCardRegistrationRequestDto {
  cardNumber: number;

  @IsNumberString()
  @Matches(/^\d{3}$/)
  cvvCode: number;

  @IsString()
  name: string;

  @IsString()
  @IsEmail()
  email: string;

  @IsString()
  password: string;

  @IsString()
  confirmPassword: string;

  @IsDate()
  @Type(() => Date)
  dateOfBirth: Date;

  @IsString()
  gender: string;

  @IsString()
  phoneNumber: string;

  @IsBoolean()
  @Equals(true)
  acceptTerms: boolean;

  @IsBoolean()
  @IsOptional()
  acceptsMarketingTerms?: boolean;

  captchaValue?: string;

  constructor(
    cardNumber: number,
    name: string,
    email: string,
    password: string,
    confirmPassword: string,
    dateOfBirth: Date,
    gender: string,
    phoneNumber: string,
    acceptTerms: boolean,
    cvvCode: number,
    acceptsMarketingTerms?: boolean,
    captchaValue?: string
  ) {
    this.cardNumber = cardNumber;
    this.name = name;
    this.email = email;
    this.password = password;
    this.confirmPassword = confirmPassword;
    this.dateOfBirth = dateOfBirth;
    this.gender = gender;
    this.phoneNumber = phoneNumber;
    this.acceptTerms = acceptTerms;
    this.acceptsMarketingTerms = acceptsMarketingTerms;
    this.cvvCode = cvvCode;
    this.captchaValue = captchaValue;
  }
}
